import { convertMarkdownToDocx, downloadDocx } from '@mohtasham/md-to-docx';

export const downloadResume = async (content: string) => {
  if (!content) {
    return;
  }

  const options = {
    style: {
      titleSize: 32,
      headingSpacing: 10,
      paragraphSpacing: 24,
      lineSpacing: 1,
      heading1Size: 32,
      heading2Size: 32,
      heading3Size: 24,
      heading4Size: 20,
      heading5Size: 18,
      paragraphSize: 24,
      listItemSize: 24,
      blockquoteSize: 24,
    },
  };

  const cleanedContent = content
    .replace(/\\\[/g, '[')
    .replace(/\\\]/g, ']')
    .replace(/\n{3,}/g, '\n\n')
    .replace(/^(#{1,4})\s+(.+)$/gm, '$1 **$2**');

  const doc = await convertMarkdownToDocx(cleanedContent, options);

  downloadDocx(doc, 'resume.docx');
};
